import { render, staticRenderFns } from "./Queue.vue?vue&type=template&id=727fcab9&scoped=true"
import script from "./Queue.vue?vue&type=script&lang=ts"
export * from "./Queue.vue?vue&type=script&lang=ts"
import style0 from "./Queue.vue?vue&type=style&index=0&id=727fcab9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727fcab9",
  null
  
)

export default component.exports